<template>
  <v-dialog v-model="value" max-width="800" persistent>
    <v-card>
      <v-card-title style="padding: 0">
        <v-toolbar color="transparent" density="compact">
          <v-toolbar-title class="text-h6" text="Добавить виджет группе пользователей"></v-toolbar-title>

          <template v-slot:append>
            <v-btn size="small" icon="mdi-close" @click="$emit('update:modelValue', false)"></v-btn>
          </template>
        </v-toolbar>
      </v-card-title>

      <v-divider style="margin: 0" class="border-opacity-100"></v-divider>

      <v-form @submit.prevent="save">
        <v-card-text>

          <v-select :menu-props="{
            closeOnClick: true,
            closeOnContentClick: true,
          }" v-model="selectedRoles" :items="roles" item-value="value" item-title="name" label="Кому отправить"
            multiple></v-select>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn :disabled="saveButtonReadOnly" text="Сохранить" type="submit"></v-btn>

          <v-btn text="Закрыть" @click="$emit('update:modelValue', false)"></v-btn>
        </v-card-actions>
      </v-form>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "shareWidgetDialog",
  emits: [
    "update:modelValue",
  ],
  props: {
    modelValue: {
      required: true,
    },
    widgetData: {
      required: true
    }
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  data() {
    return {
      roles: [],
      selectedRoles: [],
      saveButtonReadOnly: true,
    };
  },
  created() {
    this.roles = this.$model.shareWith;
    this.saveButtonReadOnly = this.selectedRoles.length ? false : true;
  },
  watch: {
    selectedRoles: function (newVal) {
      this.saveButtonReadOnly = newVal.length ? false : true;
    }
  },
  methods: {
    async save() {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/shareWidget",
          new URLSearchParams({
            role: JSON.stringify(this.selectedRoles),
            widget: this.widgetData.id,
          })
        )
        .then((response) => {
        })
        .catch((error) => {
          console.log(error);
        });
        this.$emit("update:modelValue", false);
    },
  },
};
</script>
<style lang="scss"></style>
